<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 1.tabbar-container-start -->
    <tabbar :tabbarIndex="-1"></tabbar>
    <!-- 1.tabbar-container-end -->

    <!-- 2.main-container-start -->
    <div class="main">
      <div class="swiper" ref="swiper">
        <div class="block">
          <el-carousel :interval="15000" height="240px">
            <!-- :height="bannerHeight + 'px'" -->
            <el-carousel-item v-for="(item, index) of swiper" :key="index">
              <!-- ref="bannerHeight" -->
              <img
                :src="item.advert_pic"
                style="width: 100%; background-size: 100% 100%"
                @click="clickedSwiperItem(item.advert_url)"
                @load="imgLoad"
              />
            </el-carousel-item>
          </el-carousel>
        </div>
        <marquee behavior="scroll" class="tishi">{{
          web_rolling_notice
        }}</marquee>
      </div>
      <div class="person" v-show="showFixedSearch">
        <div
          class="kefu"
          @click="clicked_OnlineService()"
          style="cursor: pointer"
        >
          <img
            style="margin-top: 30px; text-align: center"
            src="../../images/kefu.png"
          />
          <div
            style="
              height: 30px;
              line-height: 30px;
              background-color: rgb(204, 127, 12);
              color: #fff;
              margin-top: 10px;
            "
          >
            在线客服
          </div>
          <div
            style="
              height: 30px;
              line-height: 30px;
              background-color: rgb(204, 127, 12);
              color: #fff;
              margin-top: 10px;
            "
          >
            售后处理
          </div>
        </div>
      </div>
      <div class="main">
        <!-- <div class="left">
          <img
            v-if="currentPageInfo.web_bg"
            :src="currentPageInfo.web_bg"
            class="img"
          />
          <img v-else src="../../images/vip.png" class="img" />
        </div> -->
        <div class="show" v-if="web_home_popup_type != 0">

          <!-- <el-button type="text" @click="dialogVisible = true" >点击打开 Dialog</el-button> -->
          <el-dialog
            :visible.sync="dialogVisible"
            width="480px"
            :modal="false"
            custom-class="custom"
            :lock-scroll="false"
            :append-to-body="true"
            :before-close="true"
            :showClose="showClose"
            style="margin-top: 80px; text-align: center;"
          >
            <!-- modal="flase" -->
            <span
              class="welcome"
              v-if="web_home_popup_type == 1"
              @click="dialogVisible = false"
              >{{ web_home_popup_info }}
              <!-- <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">
                  <span class="read">我知道了</span>
                </el-button>
              </span> -->
            </span>
            <span
              class="welcome"
              v-if="web_home_popup_type == 2"
              @click="dialogVisible = false"
            >
              <!-- @click="link(web_home_popup_linkurl)" -->
              <img :src="web_home_popup_imgurl" alt="" width="95%" />
              <!-- <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="dialogVisible = false">
                <span class="read">我知道了</span></el-button
              >
            </span> -->
            </span>
          </el-dialog>
        </div>
        <div class="middle">
          <div class="firend">合作伙伴</div>
          <div class="main">
            <div class="bottom" ref="swiper2">
              <el-carousel :interval="15000" height="458px">
                <el-carousel-item
                  v-for="(item, index) of swiper2"
                  :key="index"
                  class="main"
                >
                  <img
                    :src="item.advert_pic"
                    width="100%"
                    height="100%"
                    @click="clickedSwiperItem(item.advert_url)"
                  />
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="main">
            <div class="tabNav">
              <div class="navOne" @click="tabOne">礼品卡兑换</div>
              <div class="navTwo" @click="tabTwo">手机号兑换</div>
            </div>
            <!-- 这个结构是tab导航对应的内容 -->
            <div class="tabContent">
              <!-- 通过v-show控制隐藏，同一时刻隐藏一个显示一个，就实现了tab栏的切换效果了 -->
              <div class="navOneBox" v-show="showTabOne">
                <div class="middle">
                  <div class="item flexStyle1 fl">
                    <div class="left">卡号</div>
                    <input
                      v-model="cardNum"
                      type="text"
                      class="right"
                      placeholder="请输入卡号"
                    />
                  </div>
                  <div class="item flexStyle1 fl">
                    <div class="left">密码</div>
                    <input
                      v-model="cardPwd"
                      type="password"
                      class="right"
                      placeholder="请输入密码"
                    />
                  </div>
                  <div class="item flexStyle1 fl">
                    <div class="left">手机号</div>
                    <input
                      v-model="phone"
                      type="text"
                      class="right"
                      placeholder="请输入手机号"
                    />
                  </div>
                  <div
                    class="item flexStyle1"
                    style="
                      text-align: left;
                      display: flex;
                      justify-content: space-around;
                      margin-left: -20px;
                    "
                  >
                    <div class="left">验证码</div>
                    <input
                      v-model="yzmCode"
                      type="text"
                      class="right right1"
                      placeholder="请输入验证码"
                      style="margin-left: -31px"
                    />
                    <div class="get flexStyle1">
                      <div style="width: 100px; float: left">
                        <validate-code
                          ref="ref_validateCode"
                          @change="changeCode"
                          width="140px"
                          style="margin-left: -36px; height: 100%"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="item flexStyle1 fl">
                    <div class="left left1" style="margin-left: -14px">
                      验证码
                    </div>
                    <input
                      v-model="code"
                      type="text"
                      class="right right1"
                      placeholder="请输入验证码"
                    />
                    <div
                      @click="getPhoneCode('message')"
                      :class="getCodeSwitch ? 'get hands' : 'get get2'"
                    >
                      {{ codeBtnText }}
                    </div>
                    <div
                      @click="getPhoneCode('voice')"
                      style="margin-left: 10px"
                      :class="getCodeSwitch ? 'get hands' : 'get get2'"
                    >
                      {{ voicecodeBtnText }}
                    </div>
                  </div>
                </div>
                <div
                  style="
                    color: rgb(204, 104, 10);
                    margin-top: 10px;
                    margin-left: 6px;
                    z-index: 999;
                  "
                >
                  兑换即代表同意<el-button
                    type="text"
                    @click="dialogVisible1 = true"
                    >《服务协议》</el-button
                  >与<el-button type="text" @click="dialogVisible2 = true"
                    >《隐私政策》</el-button
                  >

                  <el-dialog
                    title="服务协议"
                    :visible.sync="dialogVisible1"
                    :before-close="handleClose"
                    :close-on-click-modal="close_modal1"
                    :modal="true"
                    :showClose="false"
                    :center="true"
                    width="90%"
                    style="
                      background-color: #fff;
                      width: 100%;
                      margin: auto;
                      height: 90%;
                    "
                  >
                    <span v-html="web_terms_of_service"></span>
                    <span
                      slot="footer"
                      class="dialog-footer"
                      style="padding: 10px; background-color: red; color: #fff"
                    >
                      <el-button type="primary" @click="dialogVisible1 = false"
                        >同意并继续</el-button
                      >
                    </span>
                  </el-dialog>
                  <el-dialog
                    title="隐私政策"
                    :visible.sync="dialogVisible2"
                    :before-close="handleClose"
                    :close-on-click-modal="close_modal2"
                    :modal="true"
                    :showClose="false"
                    :center="true"
                    width="90%"
                    style="
                      background-color: #fff;
                      width: 100%;
                      margin: auto;
                      height: 90%;
                    "
                  >
                    <span v-html="web_privacy_policy"></span>
                    <span slot="footer" class="dialog-footer">
                      <span
                        slot="footer"
                        class="dialog-footer"
                        style="
                          padding: 10px;
                          background-color: red;
                          color: #fff;
                        "
                      >
                        <el-button
                          type="primary"
                          @click="dialogVisible2 = false"
                          >同意并继续</el-button
                        >
                      </span>
                    </span>
                  </el-dialog>
                </div>
                <div class="bottom2 flexStyle1">
                  <div
                    @click="parseBeforeVerifacation(0, '立即兑换')"
                    class="item flexStyle1 hands c-animation button"
                  >
                    立即兑换
                  </div>
                  <div
                    @click="parseBeforeVerifacation(1, '订单查询')"
                    class="item flexStyle1 hands c-animation button"
                  >
                    订单查询
                  </div>
                </div>
              </div>
              <div class="navTwoBox" v-show="showTabTwo">
                <div class="middle middle2">
                  <div class="item1 item2 flexStyle1">
                    <div class="left">手机号</div>
                    <input
                      v-model="phone2"
                      type="text"
                      class="right"
                      placeholder="请输入手机号"
                    />
                  </div>
                  <div class="item1 item2 flexStyle1">
                    <div class="left" style="margin-left: -75px"></div>
                    <input
                      v-model="Code2"
                      type="text"
                      class="right right1"
                      placeholder="请输入验证码"
                      style="margin-left: 90px"
                    />

                    <div
                      @click="getPhoneCode2('message')"
                      :class="getCodeSwitch2 ? 'get hands' : 'get get2'"
                    >
                      {{ codeBtnText2 }}
                    </div>
                    <div
                      @click="getPhoneCode2('voice')"
                      style="margin-left: 10px"
                      :class="getCodeSwitch2 ? 'get hands' : 'get get2'"
                    >
                      {{ voicecodeBtnText2 }}
                    </div>
                  </div>

                  <!-- </div> -->
                  <!-- <div class="item1 item2 flexStyle1">
                    <div class="left"></div>
                    <input
                      v-model="code2"
                      type="text"
                      class="right right1"
                      placeholder="请输入验证码"
                    />
                    <div
                      @click="getPhoneCode2"
                      :class="getCodeSwitch2 ? 'get hands' : 'get get2'"
                    >
                      {{ codeBtnText2 }}
                    </div>
                  </div> -->
                  <div class="item1 item2 flexStyle1">
                    <div class="left" style="margin-left: -59px">验证码</div>
                    <input
                      v-model="yzmCode2"
                      type="text"
                      class="right right1"
                      placeholder="请输入验证码"
                      style="margin-left: 10px"
                    />
                    <div class="get flexStyle1">
                      <div style="width: 100px; float: left">
                        <validate-code
                          class="img"
                          ref="ref_validateCode"
                          @change="changeCode2"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- <div class="item1 item2 flexStyle1">
                    <div class="left">验证码</div>
                    <input
                      v-model="yzmCode2"
                      type="text"
                      class="right right1"
                      placeholder="请输入验证码"
                    />
                    <div class="get flexStyle1">
                      <div class="left">
                        <validate-code
                          class="img"
                          ref="ref_validateCode2"
                          @change="changeCode2"
                        />
                      </div>
                    </div>
                  </div> -->
                </div>

                <div
                  style="
                    color: rgb(204, 104, 10);
                    margin-top: 10px;
                    margin-left: 40px;
                    z-index: 9999;
                  "
                >
                  兑换即代表同意<el-button
                    type="text"
                    @click="dialogVisible1 = true"
                    >《服务协议》</el-button
                  >与<el-button type="text" @click="dialogVisible2 = true"
                    >《隐私政策》</el-button
                  >

                  <el-dialog
                    title="服务协议"
                    :visible.sync="dialogVisible1"
                    :before-close="handleClose"
                    :close-on-click-modal="close_modal1"
                    :modal="true"
                    :showClose="false"
                    :center="true"
                    width="90%"
                    style="
                      background-color: #fff;
                      width: 35%;
                      margin: auto;
                      height: 35%;
                    "
                  >
                    <span v-html="web_terms_of_service"></span>
                    <span
                      slot="footer"
                      class="dialog-footer"
                      style="padding: 10px; background-color: red; color: #fff"
                    >
                      <el-button type="primary" @click="dialogVisible1 = false"
                        >同意并继续</el-button
                      >
                    </span>
                  </el-dialog>
                  <el-dialog
                    title="隐私政策"
                    :visible.sync="dialogVisible2"
                    :before-close="handleClose"
                    :close-on-click-modal="close_modal2"
                    :modal="true"
                    :showClose="false"
                    :center="true"
                    width="90%"
                    style="
                      background-color: #fff;
                      width: 35%;
                      margin: auto;
                      height: 35%;
                    "
                  >
                    <span v-html="web_privacy_policy"></span>
                    <span slot="footer" class="dialog-footer">
                      <span
                        slot="footer"
                        class="dialog-footer"
                        style="
                          padding: 10px;
                          background-color: red;
                          color: #fff;
                        "
                      >
                        <el-button
                          type="primary"
                          @click="dialogVisible2 = false"
                          >同意并继续</el-button
                        >
                      </span>
                    </span>
                  </el-dialog>
                </div>
                <div class="bottom1 flexStyle1" style="margin-left: -15px">
                  <div
                    @click="parseNoCardsBeforeVerifacation(0, '立即兑换')"
                    class="item flexStyle1 hands c-animation button"
                  >
                    立即兑换
                  </div>
                  <div
                    @click="parseNoCardsBeforeVerifacation(1, '订单查询')"
                    class="item flexStyle1 hands c-animation button"
                  >
                    订单查询
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 2.main-container-end -->

    <!-- 100.footer-container-start -->
    <c-footer></c-footer>
    <!-- 100.footer-container-end -->

    <cover :showContent="coverContent" :isShow="isShow"></cover>
  </div>
  <!-- 1.all-container-end -->
</template>
<script>
</script>

<script>
import tabbar from "../../components/tabbar/tabbar";
import footer from "../../components/footer/footer";
import cover from "../../components/cover/cover";
import yzm from "@/components/yzm/yzm";
import {
  baseURL_1,
  noCardsOnlyHavedPhone,
  homeLargeClientsRequest,
  baseInfoRequest,
  nowExchangeRequest,
  orderFindRequest,
  phoneCodeRequest,
  homeSwipereRequest,
  cardCustomizedInfoRequest,
  countryRequest,
  urlencode,
  cardInfoRequest
} from "../../public/js/service";
import { Base64 } from "js-base64";
// Vue.use(Base64);

export default {
  name: "right",
  data() {
    // 1.data
    return {
      showClose: false,
      web_home_popup_type: 0, //弹框类型
      web_home_popup_info: "", //文字
      web_home_popup_imgurl: "", //图片
      web_home_popup_linkurl: "", //图片跳转网址
      web_rolling_notice: "", //滚动公告
      close_modal: false,
      dialogVisible: true,
      showTabOne: true, // 二选一tab切换
      showTabTwo: false, // 二选一tab切换
      bannerHeight: "420px", // 1.1.1.轮播图高度
      height2: "380px", // 1.1.2.大客户轮播图高度
      yzmCode: "", // 1.2.用户输入验证码数据
      checkCode: "", // 1.3.验证码正确结果
      result: "", // 1.4.result
      cardNum: "", // 1.5.cardNum卡号
      cardPwd: "", // 1.6.cardPwd密码
      code: "", // 1.7.code验证码
      phone: "", // 1.8.phone手机号
      sysId: "", // 1.9.sysId应用ID
      codeBtnText: "短信验证码", // 1.10.验证码按钮文字
      voicecodeBtnText: "语音验证码",
      getCodeSwitch: true, // 1.11.获取验证码开关
      timer: null, // 1.12.定时器对象
      swiper: [], // 1.13.swiper
      swiper2: [], // 1.13.swiper
      url: "yy8.baidu.com", // 1.14.url获取基本信息
      largeClientList: [{}, {}, {}, {}], // 1.15.大客户列表
      currentPageInfo: {}, // 1.16.当前页面数据
      bigClientId: "", // 1.17.大客户id
      coverContent: "", // 1.18.提示内容
      isShow: false, // 1.19.是否显示
      windowTimer: null, // 1.20.地图定时器对象
      largeClientsListParsed: [], // 1.21.大客户列表数据处理之后
      exchangeType: 0, // 1.22.0正常兑换1.无卡号兑换

      phone2: "", // 1.23.手机号码
      Code2: "", // 1.24.code验证码
      codeBtnText2: "短信验证码", // 1.25.验证码按钮文字
      voicecodeBtnText2: "语音验证码",
      getCodeSwitch2: true, // 1.26.获取验证码开关
      timer2: null, // 1.27.定时器对象
      yzmCode2: "", // 1.28.用户输入验证码数据
      checkCode2: "", // 1.29.验证码正确结果
      card_customized_id: "", //定制页id
      switch_1:"",//多选多类型
      card_type:"",//卡型
      card_type_id:"",//卡型id

      web_terms_of_service: "",
      dialogVisible1: false,
      close_modal1: false,
      dialogVisible2: false,
      web_privacy_policy: "",
      showFixedSearch: false,
      close_modal2: false,
    };
  },

  components: {
    // 2.components
    tabbar,
    cFooter: footer,
    validateCode: yzm,
    cover,
  },

  methods: {
    showSearch() {
      // 获取当前滚动条向下滚动的距离
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 当页面滚动到高度300px处时，显示搜索框
      if (scrollTop > 230) {
        this.showFixedSearch = true;
      } else {
        this.showFixedSearch = false;
      }
    },

    imgLoad() {
      this.$nextTick(() => {
        this.bannerHeight = this.$refs.bannerHeight[0].height;
        // console.log(
        //   "this.$refs.bannerHeight[0].height",
        //   this.$refs.bannerHeight[0].height
        // );
      });
    },
    clicked_OnlineService() {
      var url = localStorage.web_online_service;
      if (url && url != "" && url != "#") {
        url =
          url.toLowerCase().indexOf("http:") > -1 ||
          url.toLowerCase().indexOf("https:") > -1
            ? url
            : "http://" + url;
        var tempwindow = window.open("");
        tempwindow.location = url;
      }
    },

    tabOne() {
      /*
    点击tab1的时候，让tab1显示，tab2隐藏，即showTabOne为true，showTabTwo为false
    同时修改tab1的样式使其"高亮",注意不要忘了修改tab2的样式，使其"不高亮"。
    点击tab2的时候，也是同理。
   */
      this.showTabOne = true;
      this.showTabTwo = false;
      document.querySelector(".navOne").style.backgroundColor = "#e3e3e3";
      document.querySelector(".navTwo").style.backgroundColor = "#fff";
      document.querySelector(".navOne").style.color = "#eb3341";
      document.querySelector(".navTwo").style.color = "#000";
    },
    // 二选一tab栏切换
    tabTwo() {
      this.showTabTwo = true;
      this.showTabOne = false;
      document.querySelector(".navOne").style.backgroundColor = "#fff";
      document.querySelector(".navTwo").style.backgroundColor = "#e3e3e3";
      document.querySelector(".navTwo").style.color = "#eb3341";
      document.querySelector(".navOne").style.color = "#000";
    },

    // 3.methods
    changeCode(value) {
      // 3.1.验证码改变回调函数
      this.checkCode = value;
    },

    parseBeforeVerifacation(index, name) {
      // 3.2.立即兑换or订单查询之前的验证
      // index==0立即兑换===1订单查询
      this.butsTips = "buttonName:" + name;
      let verifacationResult = this.verifacation();
      if (verifacationResult) {
        if (index === 0) {
          this.exchangeNow();
        } else if (index === 1) {
          this.watchOrder();
        }
      }
    },

    verifacation() {
      // 3.3.校验表单方法
      if (!this.cardNum.trim()) {
        // 卡号校验
        this.$notify({
          title: "提示",
          message: "请输入卡号",
        });
        return;
      }

      if (!this.cardPwd.trim()) {
        // 卡密校验
        this.$notify({
          title: "提示",
          message: "请输入密码",
        });
        return;
      }

      if (this.phone.trim().length != 11) {
        // 手机号校验
        this.$notify({
          title: "提示",
          message: "请输入11位手机号",
        });
        return;
      }

      if (!this.code.trim()) {
        // 手机号验证码校验
        this.$notify({
          title: "提示",
          message: "请输入短信验证码",
        });
        return;
      }

      if (this.yzmCode.toUpperCase() !== this.checkCode) {
        // 随机验证码验证
        this.$notify({
          title: "提示",
          message: "请输入正确验证码",
        });

        this.yzmCode = "";
        this.$refs["ref_validateCode"].draw();
        return;
      }
      return true;
    },

    getCardCustomizedInfo(obj) {
      // 获取定制页信息
      let data = {
        cardCustomizedId: this.card_customized_id,
        sysId: this.sysId,
      };

      cardCustomizedInfoRequest(data).then((res) => {
        if (res) {
          let r = res.data[0];
          localStorage.web_order_success = r.web_order_success;
          localStorage.web_order_success_2 = r.web_order_success_2;
          localStorage.web_top_imgurl = r.web_top_imgurl;
          localStorage.web_top_linkurl = r.web_top_linkurl;
          localStorage.phone_top_imgurl = r.phone_top_imgurl;
          localStorage.phone_top_linkurl = r.phone_top_linkurl;
          localStorage.phone_convert_instructions =
            r.phone_convert_instructions;
          localStorage.web_rolling_notice = r.web_rolling_notice;

          if(this.switch_1==1&&this.card_type==4){
            this.$router.push(
              "/goodsList1?obj=" + encodeURIComponent(JSON.stringify(obj))
            );
          }else{
            this.$router.push(
              "/goodsList?obj=" + encodeURIComponent(JSON.stringify(obj))
            );
          }
        }
      });
    },
    exchangeNow() {
      // 3.4.立即兑换
      if (this.currentPageInfo.web_is_order != 0) {
        // 3.4.1.检测是否允许全局兑换
        this.$notify({
          title: "提示",
          message: this.currentPageInfo.web_order_tip,
        });
      } else {
        // 3.4.2.通过接口检测，验证卡号密码，获取token
        let data_pwd = this.cardPwd;
        if (localStorage.sys_pwd_secret == "1") {
          let pwd1 = Base64.encode(data_pwd);
          let pwd2 = urlencode(pwd1);
          data_pwd = pwd2;
        }
        let data = {
          sysId: this.sysId,
          cardNum: this.cardNum,
          cardPwd: data_pwd,
          code: this.code,
          phone: this.phone,
        };

        nowExchangeRequest(data).then((res) => {
          if (res.data) {
            let r = res.data[0];
            localStorage.token = r.token;
            this.card_customized_id = r.card_customized_id;
            this.card_type_id=r.card_type_id;

            this.getCardInfo(r)
          }
        });
      }
    },
    getCardInfo(obj) {
      // 3.2.获取卡型信息
      let data = {
        cardTypeId: this.card_type_id,
        sysId: this.sysId,
        isLoadMaxQTY:1
      };

      cardInfoRequest(data).then((res) => {
        if (res) {
          let r = res.data[0];
          this.cardInfo = r;
          this.card_type = r.card_type;
          this.switch_1=r.switch_1;

          if (this.card_customized_id) {
            this.getCardCustomizedInfo(obj);
          } else {
            if(this.switch_1==1&&this.card_type==4){
              this.$router.push(
                "/goodsList1?obj=" + encodeURIComponent(JSON.stringify(obj))
              );
            }else{
              this.$router.push(
                "/goodsList?obj=" + encodeURIComponent(JSON.stringify(obj))
              );
            }
          }
        }
      });
    },

    watchOrder() {
      // 3.5.订单查询
      let data_pwd = this.cardPwd;
      if (localStorage.sys_pwd_secret == "1") {
        let pwd1 = Base64.encode(data_pwd);
        let pwd2 = urlencode(pwd1);
        data_pwd = pwd2;
      }
      let data = {
        sysId: this.sysId,
        cardNum: this.cardNum,
        cardPwd: data_pwd,
        code: this.code,
        phone: this.phone,
        is1: 1,
      };

      orderFindRequest(data).then((res) => {
        if (res) {
          this.$router.push(
            "/orderDetail?obj=" + encodeURIComponent(JSON.stringify(res.data))
          );
        }
      });
    },

    getPhoneCode(type) {
      // 3.6.获取短信验证码

      let _is_1 = true;

      if (_is_1) {
        if (!this.cardNum.trim()) {
          // 卡号校验
          this.$notify({
            title: "提示",
            message: "请输入卡号",
          });
          _is_1 = false;
        }
      }

      if (_is_1) {
        if (!this.cardPwd.trim()) {
          // 卡密校验
          this.$notify({
            title: "提示",
            message: "请输入密码",
          });
          _is_1 = false;
        }
      }

      if (_is_1) {
        if (this.phone.trim().length != 11) {
          // 手机号校验
          this.$notify({
            title: "提示",
            message: "请输入11位手机号",
          });
          _is_1 = false;
        }
      }

      if (_is_1) {
        if (this.yzmCode.toUpperCase() !== this.checkCode) {
          // 随机验证码验证
          this.$notify({
            title: "提示",
            message: "请输入正确验证码",
          });

          this.yzmCode = "";
          this.$refs["ref_validateCode"].draw();
          _is_1 = false;
        }
      }
      if (_is_1) {
        if (this.phone.trim().length != 11) {
          this.$notify({
            title: "提示",
            message: "请输入11位手机号",
          });
        } else {
          let sc = 60;
          if (this.getCodeSwitch) {
            // clearInterval(this.timer);
            // this.getCodeSwitch = false;
            // this.codeBtnText = sc + "s";

            //短信验证码
            if (type == "message") {
              this.getPhoneCodeRequest();
              this.timeCode(type);
            } else {
              //语音验证码
              this.getPhoneCodeRequest1();
              this.timeCode(type);
            }
            // this.timer = setInterval(() => {
            //   sc--;
            //   this.codeBtnText = sc + "s";
            //   if (sc < 1) {
            //     clearInterval(this.timer);
            //     this.getCodeSwitch = true;
            //     this.codeBtnText = "获取验证码";
            //   }
            // }, 1000);
          }
        }
      }
    },
    timeCode(type) {
      let sc = 60;
      clearInterval(this.timer);
      this.getCodeSwitch = false;
      this.timer = setInterval(() => {
        sc--;
        type == "message"
          ? (this.codeBtnText = sc + "s")
          : (this.voicecodeBtnText = sc + "s");
        if (sc < 1) {
          clearInterval(this.timer);
          this.getCodeSwitch = true;
          type == "message"
            ? (this.codeBtnText = "短信验证码")
            : (this.voicecodeBtnText = "语音验证码");
        }
      }, 1000);
    },
    getPhoneCodeRequest() {
      // 3.7.获取短信验证码请求
      let data = {
        phone: this.phone,
        sysId: this.sysId,
        type: 2,
      };
      phoneCodeRequest(data).then((res) => {
        if (res) {
          this.$message.success("短信发送成功!");
        } else {
          clearInterval(this.timer);
          this.getCodeSwitch = true;
          this.codeBtnText = "短信验证码";
        }
      });
    },
    getPhoneCodeRequest1() {
      // 3.7.获取语音验证码请求
      let data = {
        phone: this.phone,
        sysId: this.sysId,
        type: 2,
        type2: 1,
      };
      phoneCodeRequest(data).then((res) => {
        if (res) {
          this.$message.success("语音验证码发送成功!");
        } else {
          clearInterval(this.timer);
          this.getCodeSwitch = true;
          this.codeBtnText = "语音验证码";
        }
      });
    },
    getSwiperRequest() {
      // 3.8.获取首页轮播图方法
      let data = {
        advertType: 1,
        sysId: this.sysId,
      };

      homeSwipereRequest(data).then((res) => {
        if (res.data) {
          this.swiper = res.data;
          this.imgLoad();
          window.addEventListener("resize", () => {
            this.bannerHeight = this.$refs.bannerHeight[0].height;
            this.imgLoad();
          });
        }
      });
    },

    getSwiperRequest2() {
      // 3.8.获取合作伙伴方法
      let data = {
        advertType: 2,
        sysId: this.sysId,
      };

      homeSwipereRequest(data).then((res) => {
        if (res.data) {
          this.swiper2 = res.data;
        }
      });
    },

    clickedSwiperItem(url) {
      // 3.9.点击轮播图广告转跳方法
      window.location = url;
    },
    link(url) {
      if (url != "") {
        url =
          url.toLowerCase().indexOf("http:") > -1 ||
          url.toLowerCase().indexOf("https:") > -1
            ? url
            : "http://" + url;
        window.location = url;
      }
    },
    getBaseInfoRequest() {
      // 3.10.获取用户基本信息方法
      baseInfoRequest(this.url).then((res) => {
        console.log(res)
        let r = res.data[0];
        this.currentPageInfo = r;
        this.sysId = r.sys_id;
        if (r.web_is_index == 0) {
          this.isShow = true;
          this.coverContent = r.web_index_tip;
        }

        // 3.10.1. 存入缓存其他也页面使用部分
        localStorage.sysId = r.sys_id;
        localStorage.bigClientId = r.big_client_id;
        this.bigClientId = r.big_client_id;

        localStorage.web_tel = JSON.stringify(r.web_tel.split("\n\n")); // 3.10.2.tabbar和footer公用部分数据
        localStorage.web_icp = r.web_icp;
        localStorage.web_title = r.web_title;
        localStorage.web_logo = r.web_logo;
        localStorage.web_name = r.web_name;
        localStorage.web_copyright = r.web_copyright;

        localStorage.web_is_order = r.web_is_order; // 3.10.3.限制全局兑换数据
        localStorage.web_index_tip = r.web_index_tip;

        localStorage.citys_path = r.citys_path; // 3.10.4.地址请求地址接口

        localStorage.web_bgdh = r.web_bgdh; // 3.10.5.礼品兑换背景板
        localStorage.web_bgcx = r.web_bgcx; // 3.10.6.订单查询的背景板
        localStorage.web_rolling_notice = r.web_rolling_notice; //滚动公告
        localStorage.web_home_popup_type = r.web_home_popup_type; //pc首页弹窗类型（0为不显示|1为文字|2为图片）
        if (r.web_home_popup_type == 0) {
          this.showClose = false;
        } else {
          this.showClose = true;
        }
        localStorage.web_home_popup_info = r.web_home_popup_info; //pc首页弹窗-文字
        localStorage.web_home_popup_imgurl = r.web_home_popup_imgurl; //pc首页弹窗-图片链接
        localStorage.web_home_popup_linkurl = r.web_home_popup_linkurl; //pc首页弹窗-图片跳转链接
        localStorage.phone_home_popup_type = r.phone_home_popup_type; //手机首页弹窗类型（0为不显示|1为文字|2为图片）
        localStorage.phone_home_popup_info = r.phone_home_popup_info; //手机首页弹窗-文字
        localStorage.phone_home_popup_imgurl = r.phone_home_popup_imgurl; //手机首页弹窗-图片链接
        localStorage.phone_home_popup_linkurl = r.phone_home_popup_linkurl; //手机首页弹窗-图片跳转链接
        localStorage.web_privacy_policy = r.web_privacy_policy; //隐私协议
        localStorage.web_terms_of_service = r.web_terms_of_service; //服务协议
        localStorage.web_order_success = r.web_order_success; //下单成功提示语
        localStorage.web_order_success_2 = r.web_order_success_2; //下单成功配送说明
        localStorage.web_top_imgurl = r.web_top_imgurl; //pc顶部图片链接
        localStorage.web_top_linkurl = r.web_top_linkurl; //pc顶部跳转链接
        localStorage.phone_top_imgurl = r.phone_top_imgurl; //手机顶部图片链接
        localStorage.phone_top_linkurl = r.phone_top_linkurl; //手机顶部跳转链接
        localStorage.phone_convert_instructions = r.phone_convert_instructions; //手机兑换说明
        localStorage.web_convert_instructions = r.web_convert_instructions; //pc兑换说明
        localStorage.web_online_service = r.web_online_service; //在线客服
        localStorage.web_order_success_imgurl = r.web_order_success_imgurl;
        localStorage.web_is_card_order_phone = r.web_is_card_order_phone;
        // this.parseAddress(r.citys_path);
        localStorage.sys_pwd_secret = r.sys_pwd_secret;

        this.getSwiperRequest();
        this.getSwiperRequest2();
        this.getLargeClientsList();
        window.document.title = r.web_title;
      });
    },

    getLargeClientsList() {
      // 3.11.获取大客户列表
      let data = {
        sysId: this.sysId,
      };

      homeLargeClientsRequest(data).then((res) => {
        this.largeClientList = res.data[0];
        this.largeClientsParseFunction([...res.data[0]]); // 3.11.1.数据结构方法不用调用了，后端来处理直接返回
      });
    },

    largeClientBtns(item) {
      // 3.12.点击大客户按钮
      localStorage.bigClientId = item.big_client_id; // 3.12.1.点击大客户重置大客户id
      localStorage.web_bgdh = ""; // 3.12.2.点击大客户清空缓存中默认的两张广告图，重新获取存入缓存
      localStorage.web_bgcx = "";
      this.$router.push("/giftExchange");
    },

    parseAddress() {
      countryRequest().then((res) => {
        localStorage.country = JSON.stringify(res);
      });

      return;
    },

    largeClientsParseFunction(arr) {
      // 3.14.大客户规定格式数据处理
      while (arr.length > 0) {
        let arrSon = [];
        for (let i = 0; i < 6; i++) {
          let newObj = arr.shift();
          if (newObj) {
            arrSon.push(newObj);
          }
        }
        this.largeClientsListParsed.push(arrSon);
      }
    },

    parseNoCardsBeforeVerifacation(type) {
      // 3.15.无卡兑换之前验证
      if (type != 0) {
        return;
      }

      if (this.phone2.trim().length != 11) {
        // 手机号校验
        this.$notify({
          title: "提示",
          message: "请输入11位手机号",
        });
        return;
      }

      if (!this.code2.trim()) {
        // 手机号验证码校验
        this.$notify({
          title: "提示",
          message: "请输入短信验证码",
        });
        return;
      }

      if (this.yzmCode2.toUpperCase() !== this.checkCode2) {
        // 随机验证码验证
        this.$notify({
          title: "提示",
          message: "请输入正确验证码",
        });

        this.yzmCode2 = "";
        this.$refs["ref_validateCode2"].draw();
        return;
      }

      this.noCardExchangeRequest();
    },

    getPhoneCode2(type) {
      // 3.16.获取短信验证码
      if (this.phone2.trim().length != 11) {
        this.$notify({
          title: "提示",
          message: "请输入11位手机号",
        });
        return;
      }

      let sc = 60;
      if (this.getCodeSwitch2) {
        // clearInterval(this.timer2);
        // this.getCodeSwitch2 = false;
        // this.codeBtnText2 = sc + "s";
        if (type == "message") {
          this.getPhoneCodeRequest2();
          this.timeCode1(type);
        } else {
          //语音验证码
          this.getPhoneCodeRequests2();
          this.timeCode1(type);
        }
        // this.timer2 = setInterval(() => {
        //   sc--;
        //   this.codeBtnText2 = sc + "s";
        //   if (sc < 1) {
        //     clearInterval(this.timer2);
        //     this.getCodeSwitch2 = true;
        //     this.codeBtnText2 = "获取验证码";
        //   }
        // }, 1000);
      }
    },
    timeCode1(type) {
      let sc = 60;
      clearInterval(this.timer2);
      this.getCodeSwitch2 = false;
      this.timer2 = setInterval(() => {
        sc--;
        type == "message"
          ? (this.codeBtnText2 = sc + "s")
          : (this.voicecodeBtnText2 = sc + "s");
        if (sc < 1) {
          clearInterval(this.timer2);
          this.getCodeSwitch2 = true;
          type == "message"
            ? (this.codeBtnText2 = "短信验证码")
            : (this.voicecodeBtnText2 = "语音验证码");
        }
      }, 1000);
    },
    getPhoneCodeRequest2() {
      // 3.17.获取短信验证码请求
      let data = {
        phone: this.phone2,
        sysId: this.sysId,
        type: 4,
      };

      phoneCodeRequest(data).then((res) => {
        if (res) {
          this.$message.success("短信发送成功!");
        } else {
          clearInterval(this.timer2);
          this.getCodeSwitch2 = true;
          this.codeBtnText2 = "短信验证码";
        }
      });
    },
    getPhoneCodeRequests2() {
      // 3.17.获取语音验证码请求
      let data = {
        phone: this.phone2,
        sysId: this.sysId,
        type: 4,
        type2: 1,
      };

      phoneCodeRequest(data).then((res) => {
        if (res) {
          this.$message.success("语音验证码发送成功!");
        } else {
          clearInterval(this.timer2);
          this.getCodeSwitch2 = true;
          this.codeBtnText2 = "语音验证码";
        }
      });
    },
    handleClose() {},
    changeCode2(value) {
      // 3.18.验证码改变回调函数
      this.checkCode2 = value;
    },

    noCardExchangeRequest() {
      // 3.19.无卡号请求
      let data = {
        phone: this.phone2,
        code: this.code2,
        sysId: this.sysId,
      };

      noCardsOnlyHavedPhone(data).then((res) => {
        if (res) {
          localStorage.token = res.data[0].token;

          let obj = res.data[0];
          obj.sysId = this.sysId;
          this.$router.push(
            "/chooseCards?obj=" + encodeURIComponent(JSON.stringify(obj))
          );
        }
      });
    },
  },
  mounted() {
    // 4.mounted
    this.sysId = localStorage.sysId || "";
    this.bannerHeight = this.$refs.swiper.offsetHeight;
    this.height2 = this.$refs.swiper2.offsetHeight + "px";
    this.web_rolling_notice = localStorage.web_rolling_notice || ""; //滚动公告
    this.web_home_popup_info = localStorage.web_home_popup_info || ""; //文字
    this.web_home_popup_type = localStorage.web_home_popup_type || 0;
    this.web_home_popup_imgurl = localStorage.web_home_popup_imgurl || "";
    this.web_home_popup_linkurl = localStorage.web_home_popup_linkurl || "";

    this.web_terms_of_service = localStorage.web_terms_of_service || "";
    this.web_privacy_policy = localStorage.web_privacy_policy || "";
    window.addEventListener("scroll", this.showSearch, false);
    this.url = window.location.hostname;
    if (
      this.url == "192.168.31.6" ||
      this.url == "app94.ksdemo.cn" ||
      this.url == "192.168.43.78"
    ) {
      this.url = "yy8.baidu.com";
      this.url = "bbbb.card.vue.waiwubang.com";
    }

    let urlInterInfo = window.location.search;
    if (urlInterInfo.substring(1, 5) == "bcid") {
      let bigClientId = urlInterInfo.substring(6);
      if (!isNaN(bigClientId)) {
        this.bigClientId = bigClientId;
        localStorage.bigClientId = bigClientId;
      }
    }
    this.getBaseInfoRequest();
    this.parseAddress();
  },
  computed: {
    //这里设置banner 是在900像素下高度为200px，我的banner图格式为1920X900像素
    autoHeight() {
      let _w =
        document.documentElement.clientWidth || document.body.clientWidth;
      return (_w * 200) / 450 + "px";
    },
  },
};
</script>

<style scoped lang="scss">
@import "./home.scss";
body,
html {
  width: 100%;

  height: 100%;

  margin: 0;

  padding: 0;

  overflow: hidden;
}
.navOne {
  width: 30%;
  height: 100%;
  text-align: center;
  line-height: 30px;
  float: left;
  background-color: #e3e3e3;
  color: #eb3341;
  font-size: 20px;
}
.navTwo {
  width: 30%;
  height: 100%;
  line-height: 30px;
  text-align: center;
  float: left;
  font-size: 20px;
}
.navOneBox {
  // width:  px2vw(300px);
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  margin-left: 24px;
  margin-top: 15px;
}
.navTwoBox {
  margin-left: 10px;
  margin-top: 50px;
}
.tabNav {
  width: 200px;
  min-width: 420px;
  min-height: 30px;
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: center;
  margin-top: 15px;
  margin-left: 4%;
}
.item {
  margin-top: 20px;
}
input {
  width: 260px;
  height: 30px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin: 0px 10px 0px 10px;
  padding-left: 10px;
}
.button {
  width: 100px;
  height: 30px;
  line-height: 30px;
  color: #fff;
  background-color: #eb3341;
  margin-left: 20px;
  border-radius: 4px;
}
.left1 {
  // margin-left: -60px;
  margin-right: 10px;
}
.right1 {
  width: 100px;
  margin-left: 4px;
}
// .item {
//   margin-left:62px;
//   margin-top: 11px;
// }
.item1 {
  margin-left: 10px;
  margin-top: 20px;
}
// .bottom {
//   margin-left: 40px;
//   margin-top: -18px;
// }
.button1 {
  width: 100px;
  height: 30px;
  line-height: 30px;
  color: #fff;
  background-color: #eb3341;
  margin-left: 1px;
}
.welcome {
  color: #eb3341;
}
.zhen {
  color: coral;
  font-size: 24px;
  margin-left: 70px;
}

.fl {
  display: flex;
  justify-content: space-around;
}
.bottom1 {
  margin-left: -100px;
}
.bottom2 {
  margin-left: -30px;
  // margin: auto;
}
.lunbo {
  width: 100%;
}

/deep/.el-dialog {
  background: none;
  box-shadow: none;
  margin-top: 0px !important;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: #a1a1a1 0 0 10px;
}
.read {
  width: 150px;
  height: 30px;
  line-height: 30px;
  background-color: #f8eec7;
  border: 2px solid #ffdc71;
  color: #b06411;
  padding: 10px 65px;
  position: relative;
  top: -94px;
  left: 0px;
  border-radius: 10px;
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
}
.le {
  margin-left: -4%;
}
.left {
  width: 80px;
  float: left;
  text-align: justify;
  text-align-last: justify;
}
/deep/.el-dialog__headerbtn {
  position: relative;
  top: 0;
  left: 210px;
  font-size: 30px;
}
</style>